<template >
 <div>
   <leftovers-chart></leftovers-chart> 
 </div>
</template>

<script>

import LeftoversChart from './chart/LeftoversChart'
export default {
  name: 'Consumption',
  components: {
    LeftoversChart
  },

  mounted () {
  },

  data: () => ({
    selectedId: null,
    loaded: false
  }),

}
</script>
